import IPixelMapDay from "@interfaces/pixel-map-day.interface";

const septemberMap: Array<IPixelMapDay> = [
	{
		status: "above-average",
		reason: `
			I did a major overhaul to the calendar entries to actually support **Markdown**, yay! I guess, moving forward, my entries might get a little more expressive.

			I was a little bit anxious today about what'll happen tomorrow, but I assured myself that things will be okay no matter what. And, if things end or something, I *still* have something to look forward to. So all-in-all, I was able to enjoy my day. I played Phasmophobia with friends and had enough free time to work on a [login](/login) page for my website.

			I also was able to talk to a few friends today and got to console one who was worrying about how their life will proceed. I think I did a pretty good job at it, *I guess*.
		`,
		spotify: {
			artist: "STAYC",
			song: "Bubble",
			link: "https://open.spotify.com/track/4P5ozkI1bxiGxA5rZ27jlO?si=3a77bc2f186a43c8",
			album: "TEENFRESH"
		}
	},
	{
		status: "below-average",
		reason: `
			I tried to distract myself by hanging out with my RC friends on Discord. But a whole day going by without a message from my friends just feels off. I don't know. Maybe it's time to go through with my decision.
		`,
		spotify: {
			artist: "STAYC",
			song: "Bubble",
			link: "https://open.spotify.com/track/4P5ozkI1bxiGxA5rZ27jlO?si=3a77bc2f186a43c8",
			album: "TEENFRESH"
		}
	},
	{
		status: "awful",
		title: "Past Lives",
		icon: "rainy",
		reason: `
			I went out alone to Venice Grand Plaza today to watch Past Lives. I've been having a decision on my mind lately and I thought that a film would help me feel better.

			Turns out it made me feel worse! It was the actual worst type of film that I could've watched. I was dealing with grief and loss and here I was, watching a movie about grief and loss.

			Needless to say, it didn't help and I went home to tell my friends that I wasn't feeling okay. They weren't feeling okay in return and we had a long conversation about it. Ultimately, I decided not to change anything about my stance and pushed through, despite them trying to talk me out of it and that things would be normal again tomorrow.
		`,
		spotify: {
			artist: "Katy Perry",
			song: "The One That Got Away",
			link: "https://open.spotify.com/track/3oL3XRtkP1WVbMxf7dtTdu?si=104cb88f28a248e6",
			album: "Teenage Dream"
		}
	},
	{
		status: "awful",
		title: "Here, Once More, In...",
		icon: "steps",
		reason: `
			I asserted boundaries and maintained my stance today. I thought it would result in understanding, or further growth, but I'm met with a goodbye. Hearing a goodbye wasn't easy because I, myself, am not ready to say that yet. But I still got that. Also paired that with my poor physical health/mood.

			Although I miss them and I want to go back to them, I'm torn between making a choice for the betterment of me, or keeping the same.
		`,
		spotify: {
			artist: "Bruno Major",
			song: "Regent's Park",
			link: "https://open.spotify.com/track/2qiDXgq5fL1FetkhX5xi9L?si=66ba7e955b4f4b82",
			album: "To Let A Good Thing Die"
		},
		resonatedLyrics: [
			"But now we're here in Regent's Park",
			"Amongst the flowers and I wish it would rain",
			"'Cause in the sun, you look so lovely",
			"That I'm falling for you over again",
			"Since I have nothing left to say",
			"That will make you change your mind",
			"I'll say goodbye on a beautiful spring day",
		]
	},
	{
		status: "above-average",
		title: "It’s Okay, Bro. We Win Late Game",
		reason: `
			"Man, don't worry. It'll be okay, bro. We win late game," a voice kept reassuring me the entire day.

			I was still, you know, not okay and not at ease ever since yesterday. I kept *trying* (emphasis on "try") to be okay, although I couldn't really stop myself from turning into a wreck. I knew I was going to be okay, but the anxiety stems from me not knowing *how* I'll be okay. I kept looking at patterns and consulted my mood calendar.

			I thought my life had returned to its normal, boring everyday routine once again. For good, this time.

			But nope. I was wrong.
		`,
		spotify: {
			artist: "Lady Gaga",
			song: "Paparazzi",
			link: "https://open.spotify.com/track/02XnQdf7sipaKBBHixz3Zp?si=b827c9d9b2154095",
			album: "The Fame"
		}
	},
	{
		status: "good",
		title: "Normal",
		reason: `
			Today was a normal day. I talked to friends, watched scary videos, I got teased, played Phasmophobia with friends.

			Things today were fairly calm, boring, and familiar. I guess that's the beauty of it. I'm perfectly happy today and, after going through a temporary loss of it, I have deep adoration for how routine things are. And maybe, *just maybe* that's good enough.

			Maybe that's all I need for now.

			### PS
			I tried ordering no-frills cookies and choco mallows and **it was a logistical nightmare**. I started ordering at 4:00 p.m. and finally got the cookies around 7:10 p.m.
		`,
		spotify: {
			artist: "Camilla Cabello, Shawn Mendes",
			song: "Señorita",
			link: "https://open.spotify.com/track/0TK2YIli7K1leLovkQiNik?si=1f04bbe12b454b6e",
			album: "Señorita"
		}
	},
	{
		status: "above-average",
		reason: `
			Things were fairly-normal today.
		`,
		spotify: {
			artist: "Justin Bieber",
			song: "Somebody To Love",
			link: "https://open.spotify.com/track/3rLIv187BhjyweFe89SgLn?si=3435a7f114f74ffe",
			album: "My World 2.0"
		}
	},
	{
		status: "above-average",
		title: "Sunkissed",
		icon: "sunny",
		reason: `
			I finished integrating React into [my blog's theme](https://dartegnian.com) and it looks great! The color of the website now changes based on the post's image. Yay!

			Nevertheless, Friday was actually a fun day. I got to do the usual rounds of playing Phasmophobia with work friends after my shift, talking to friends, and enjoying some things  at work.
		`,
		spotify: {
			artist: "khai dreams",
			song: "Sunkissed",
			link: "https://open.spotify.com/track/34RmzDXMv0ELSQTK4pNvX3?si=dfefbce1f4a04056",
			album: "Now and Then"
		},
		resonatedLyrics: [
			"So softly, a tender breeze brush against my knees",
			"On a summer afternoon",
			"I get to thinkin' 'bout the hazy days",
			"Under August shade that I used to spend with you",
			"",
			"I didn't realize it was all I wanted, what I had",
			"My riddled heart, I had to cradle back together just to see"
		]
	},
	{
		status: "above-average",
		reason: `
			I spent most of the day by myself, relaxing and doing the things I find personally enjoyable.

			In the evening, I got scolded by my friends because I was playing Overwatch over doing something else. This kinda irked me because I spend most of my time on other things and this was the only time I got to play a game **I personally enjoyed**. Pissed me off a little.

			I'm busy with my own things and I don't owe anyone an explanation, but it's just so annoying and even infuriating to an extent. I had a good day regardless, but I just *hate it* when people tell me what not or what to do, or how to go about my life. I'm glad I didn't lash out on them, I'm leaving it at that.
		`,
		spotify: {
			artist: "Linkin Park",
			song: "Points of Authority",
			link: "https://open.spotify.com/track/5egqKwgK5r5rvGD1LrtR7J?si=4a34c7b519014d6a",
			album: "Hybrid Theory"
		},
	},
	{
		status: "good",
		reason: `
			Today was really fun, my friends invited me to out with them. But it had to be rescheduled because they were going to get a haircut. I mostly played Phasmophobia with them, though, and had fun in the evening.
		`,
		spotify: {
			artist: "He Is We",
			song: "All About Us (feat. Owl City)",
			link: "https://open.spotify.com/track/2185NMvk68x92ygV1iP89F?si=5f797209af494112",
			album: "All About Us"
		},
	},
	{
		status: "excellent",
		icon: "ramen_dining",
		title: "Ramen Out!",
		reason: `
			Monday started out as a usual, normal day. My friends and I arranged to meet at a mall and decided to eat at a restaurant. I'm surprised that we're gonna see each other so casually after work.

			So we met up at this mall, at Marugame Udon. They got beef udon and I got some spicy beef udon bowl. We both had fun, just talking and eating. They told me about what song kept on playing in their head and I told them that there was also a song that was looping through my head, but they weren't interested in hearing it. Before going home, we got candy at Candy Corner and the candies we got were super expensive.

			We both got home and still had time to play a few rounds of Phasmo before ending the evening as usual.
		`,
		spotify: {
			artist: "tripleS",
			song: "Girls' Capitalism",
			link: "https://open.spotify.com/track/2ivVS2ageitCQqnmmMaWoH?si=ac5ef0d5960e4bab",
			album: "LOVElution <ↀ>"
		},
	},
	{
		status: "bad",
		reason: `
			I kept looking back at old screenshots to remind myself of what I had lost. I remembered Jaze and my IMC friends back then, and how secure + comfortable I felt with them. I also got to see how my life was like  back then. It made me really sad throughout the entire day because I had lost people I was so secure with. People who I thought would always be by my side and stand by me. I guess that's all over now and I'm here. I chose this path, not gonna lie.

			This day was extremely weird, and draining. I miss having a safe space and I wish I can have people I can lean back on. 2023 has been exhausting for me because my friends (and even 5-year-strong best friend) have left my side, and losing people remains my greatest fear. I feel like I've been such a lousy friend.

			I really, really regret not listening to my friends back then.
		`,
		spotify: {
			artist: "Kitty Kallen",
			album: "Little Things Mean a Lot",
			song: "It's Been a Long, Long Time",
			link: "https://open.spotify.com/track/2jBk4wSHTYON7kgHZ7Ob5J?si=318767bcf6c44538"
		}
	},
	{
		status: "above-average",
		reason: `
			Had a usual, fun day. Played some rounds of Phasmophobia after work.
		`,
		spotify: {
			artist: "Harry Styles",
			song: "As It Was",
			link: "https://open.spotify.com/track/4Dvkj6JhhA12EX05fT7y2e?si=39e42f9a0ad74c01",
			album: "Harry's House"
		},
		resonatedLyrics: [
			"In this world, it's just us",
			"You know it's not the same as it was",
			"As it was, as it was",
			"You know it's not the same"
		]
	},
	{
		status: "above-average",
		icon: "sports_esports",
		title: "Controller Time",
		reason: `
			I **finally** got my PS5 controller back after not having it for 2 months. Getting it back from warranty was a pain, but I'm glad to have it back and play those games again.

			Other than that, today was a normal, run-of-the-mill day.
		`,
		spotify: {
			artist: "Harry Styles",
			song: "As It Was",
			link: "https://open.spotify.com/track/4Dvkj6JhhA12EX05fT7y2e?si=39e42f9a0ad74c01",
			album: "Harry's House"
		},
	},
	{
		status: "above-average",
		reason: `
			It's cool that I got my friends confiding in me.

			After that, it was a few fun rounds of Phasmo, with the last game leaving me and my friends left as the only survivors. It was a team effort but we managed to solve the ghost and got the biggest win we've ever had in that game. I'm glad, so today was pretty fun.
		`,
		spotify: {
			artist: "Taylor Swift",
			album: "Midnights (The Til Dawn Edition)",
			song: "Hits Different",
			link: "https://open.spotify.com/track/3xYJScVfxByb61dYHTwiby?si=5506991dff464f58"
		},
		resonatedLyrics: [
			"Oh my, love is a lie",
			"Shit my friends say to get me by",
			"It hits different",
			"It hits different this time"
		]
	},
	{
		status: "good",
		title: "An Amazing Spider-Day",
		icon: "pest_control",
		reason: `
			I got to finish playing Spider-Man Remastered on the PC! And I had fun re-watching Across the Spider-Verse (which I originally watched in theaters June 1).

			I also got to play some controller-only games like WipEout and SSX Tricky. Both were really fun and so was using the controller in general. Nothing else happened today, and I didn't talk to anyone else online either. Today was just a really quiet, peaceful day.
		`,
	},
	{
		status: "below-average",
		reason: `
			I tried to play other games with the controller.
		`,
		spotify: {
			artist: "Bob Marley & The Wailers",
			album: "Legend - The Best Of Bob Marley And The Wailers",
			song: "Jamming",
			link: "https://open.spotify.com/track/4aUCPal9bxTnQkEfdIY6sG?si=d080e9082cb84fcc"
		},
	},
	{
		status: "good",
		title: "2scary4me",
		icon: "skull",
		reason: `
			It was the start of a usual, normal week for me.

			In the afternoon, I watched Ju-on: The Grudge and it still terrified me. I'm a big fan of everything horror and occult, and have watched so many horror movies in 2021, but I'm still scared of Kayako from The Grudge. In the evening, I was too spooked and creeped out.

			Around evening, I played Phasmophobia with friends from work and after that I got to start on playing Need For Speed: Carbon. Overall it was a fun, frightening day.
		`,
		spotify: {
			artist: "Metro Boomin",
			album: "METRO BOOMIN PRESENTS SPIDER-MAN: ACROSS THE SPIDER-VERSE (SOUNDTRACK FROM AND INSPIRED BY THE MOTION PICTURE)",
			song: "Am I Dreaming (Metro Boomin & A$AP Rocky, Roisee)",
			link: "https://open.spotify.com/track/6Ec5LeRzkisa5KJtwLfOoW?si=538f392031c643dc"
		},
	},
	{
		status: "above-average",
		reason: `
			Today was a pretty normal, okay Tuesday. I watched Ringu (1998) during lunchtime but didn't really finish the movie.

			After work, it was your usual: Phasmophobia with friends and a chill evening after that. Only, it wasn't *that* chill for me. I kept replaying a song from Taeyeon that I loved a lot in 2017. It's been 6 years, but the song still rings true. I feel a great amount of loneliness and it wasn't easy to go through and realize.
		`,
		spotify: {
			artist: "Taeyeon",
			album: "My Voice - The 1st Album (Deluxe Edition)",
			song: "Lonely Night",
			link: "https://open.spotify.com/track/5Uj6v222teNJ5KbD2yuw5u?si=c1b69e783da9419c"
		},
		resonatedLyrics: [
			"I’m sick of lonely nights",
			"I’m sick of lonely nights"
		]
	},
	{
		status: "above-average",
		reason: `
			I woke up late and tired but still continued a normal day.

			I invited my friends and my work friends to play Phasmo but the others weren't available, but we still played and we had a really bad run of not finding the correct ghosts. The day was okay, I guess. Tiring, but fun enough.
		`,
		spotify: {
			artist: "Nick Lopez",
			album: "Pink Champagne",
			song: "Pink Champagne",
			link: "https://open.spotify.com/track/7yGg7Lk289zgz2RJvlXfvg?si=44c9a52f91554bb3"
		},
		resonatedLyrics: [
			"You got that big, big bubble butt",
			"Better keep my mouth shut",
			"I'll just watch you do your thing",
			"Sippin' on that pink champagne, yeah",
			"Girl, go to work",
			"Dance in that oversized 1980's Rolling Stones t-shirt"
		]
	},
	{
		status: "below-average",
		reason: `
			Something about this day just didn't feel right.
		`,
		spotify: {
			artist: "Destiny's Child",
			album: "Destiny Fulfilled",
			song: "Cater 2 U",
			link: "https://open.spotify.com/track/0FZvjrHpAmLKj574M4VwrF?si=3ef21d2ab2264047"
		},
	},
	{
		status: "below-average",
		reason: `
			I woke up really, really late for work today. Like, 2 hours late. I don't know why, but I guess it has something to do with the AC being on throughout the whole night.
			
			After that, I really wasn't okay. I was in the middle of choosing to either:

			1. Following my feelings and staying hurt
			2. Try to be okay and continue the day as I usually would.

			I chose the latter, thankfully, and continued on with it being as normal as can be. The day didn't turn out into a complete wreck. For once, I actually chose to steer clear of my feelings and try to be okay. Even I'm surprised.
		`,
		spotify: {
			artist: "AJR",
			song: "Way Less Sad",
			link: "https://open.spotify.com/track/6YIivt0G3ZUuNrM62jp9pL?si=70925e0fe4204306",
			album: "OK ORCHESTRA"
		},
	},
	{
		status: "special",
		icon: "water_lux",
		title: "Ocean Park Shenanigans",
		reason: `
			I got very short rest (like, **a nap**) before preparing to head out to this month's long-awaited event: my former company's Family Day! I was so stoked and happy that I woke up at the right time. I prepared my usual things and then headed to the venue, despite the weather worsening. I got to Manila Ocean Park and the rain was *pouring*, it was a torrent of rain. But I got into the venue okay and was greeted by a buffet and my old coworkers.

			I can't stress this enough: I really, *really* miss my old coworkers. My time in KVH was so short and it was almost 5 years ago, but it's touching that I'm still so close with them. With how eventful my life has been over the past 3 years, I've forgotten that chapter of my life which was my first workplace.

			Anyway, everyone was there including Nikka. I spent the day with Nikka, CJ, Levi, and ate Ange. We had fun taking pictures, watching the show, and just enjoying each other's company. We were so tired and walked so many steps. Everyone had a great time, I think, and I got to spend time with my old coworkers.

			All in all, it was actually pretty fun. I talked to a lot of people, I spent a lot of time with my friends, and it genuinely lived up to the hype. I had fun on my own and this was a special day to me.
		`,
		spotify: {
			artist: "aespa",
			album: "Savage - The 1st Mini Album",
			song: "YEPPI YEPPI",
			link: "https://open.spotify.com/track/3UKKwGrpWWamc0XNSKXjmz?si=898a6198fc9c45b1"
		},
	},
	{
		status: "below-average",
		reason: `
			Today was mostly a chill day, I woke up at 11 am. In the evening, I invited some friends over for Phasmophobia and spent a few rounds figuring out the ghost.

			I don't know why, but for some reason I had a really bad swing of anxiety rush over me.

			Exhausted, I gave up and eventually slept.
		`,
		spotify: {
			artist: "DNCE",
			album: "DNCE",
			song: "Toothbrush",
			link: "https://open.spotify.com/track/7ciLq0Cip0yxiz6KANrOUq?si=6e14a2c4b6fb450c"
		},
	},
	{
		status: "good",
		title: "Progress Requires...",
		reason: `
			Today was the start of a usual Monday for me.

			I also realized a big blunder I made at work, so I tried to rectify that. Lunch went on as usual, with me watching movie recaps of The Grudge. Around the end of my shift, I played "Buko" by Jireh Lim, then I showed my friends a trashy couple on 90 Day Fiancé.

			My head was so annoyed and irritated that I wanted something done with my life. I looked at my health and I found out that I was dangerously on the brink. **I am at my worst-ever state, period.** I just realized how much of a low point I am in my life. But then I remembered this quote from my epiphany last year:

			> Progress requires a consistent, sustained struggle. A willingness to disrupt everyday life.

			I *need* to make changes. I'm not going to let my spirit be beaten down. I made a promise to myself that I would do better for my future self and, even though I was on the brink, I'm not going to let my spirit falter. I'm not backing down without a fight and here we are again on a fight for my life.

			And I worked out, too. Thankfully.
		`,
		spotify: {
			artist: "Jireh Lim",
			album: "Love And Soul",
			song: "Buko",
			link: "https://open.spotify.com/track/5uH5Gl7brNoFCpR9Ds9k94?si=ea141293daab45a9"
		},
		resonatedLyrics: [
			"Buo ang araw ko",
			"Marinig ko lang ang mga himig mo",
			"",
			"Hindi ko man alam kung nasa'n ka",
			"Wala man tayong komunikasyon",
			"Maghihintay sa 'yo buong magdamag"
		]
	},
	{
		status: "above-average",
		reason: `
			This day was just like any other day and nothing was out of the ordinary, except for me waking up late. Today also marks the first day I stop any intake of coffee, so that's one.

			In the afternoon, I watched Hereditary. Around evening, I played Phasmophobia with my friends and we got a few games right through some game mechanic and teamwork.

			I slept after playing and thankfully didn't oversleep at all, even though I thought I would.
		`,
		spotify: {
			song: "You Can Call Me Al",
			artist: "Paul Simon",
			link: "https://open.spotify.com/track/0qxYx4F3vm1AOnfux6dDxP?si=69f3bddaefa442c0",
			album: "Graceland (25th Anniversary Deluxe Edition)"
		}
	},
	{
		status: "above-average",
		reason: `
			I updated my MacBook to macOS 14 today and it was okay. It was also the day that Taylor Swift's Eras Tour movie would premier worldwide. In the afternoon, I listened to songs from The Pussycat Dolls and watched some ghost stories. After working, I played Phasmophobia with my friends and a friend from work.
			
			Life sucks and I don't meet anyone interesting these days that'll stick, no matter how much I wish I would.

			Maybe some other day.
		`,
		spotify: {
			song: "Jai Ho! (You Are My Destiny)",
			artist: "A.R. Rahman, The Pussycat Dolls",
			link: "https://open.spotify.com/track/7Kpqjspw4Y7HrvItIRcBiW?si=262d5480a9234c2d",
			album: "Jai Ho! (You Are My Destiny)"
		}
	},
	{
		status: "above-average",
		reason: `
			I got to play Counter-Strike 2 today! I felt some insecurity, but nothing much.

			In the evening, I still got to play Phasmophobia with my friends and that was pretty much a normal day for me.
		`,
	},
	{
		status: "above-average",
		reason: `
			Today was pretty weird, I had some turbulent feelings unresolved from yesterday and I didn't really have anyone to share them with. I did my best to not let them show, but I was feeling very off today.
			
			I still got to play Phasmophobia with my friends. We won a few games, lost quite a lot, but it was still fun. I also got to talk with Kai, Max, Meryll, and Rachel today so I feel pretty fulfilled, social interaction-wise. I might go out with Max and Meryll next month to hang out and go bar-hopping, so that's something I'm looking forward to for October.
		`,
		spotify: {
			song: "Le Festin",
			artist: "Michael Giacchino, Camille",
			link: "https://open.spotify.com/track/02JIdsrod3BYucThfUFDUX?si=0bc297209c4b4df1",
			album: "Ratatouille (Original Motion Picture Soundtrack)"
		}
	},
	{
		status: "good",
		title: "Clean Drift",
		icon: "directions_car",
		reason: `
			I woke up today feeling good and that I got enough sleep over the night. I played some controller games and got back into racing games.

			In the afternoon, I had to clean my room while my sister was cleaning some parts of the house. Mom was coming home soon so I had to help in cleaning wherever I can. Cleaning felt like 5 hours but I was surprised that it took *less* than 3 hours. I didn't know I could clean that much in such a short amount of time.

			After cleaning up, I invited my sister and her boyfriend to play Tekken 7 with me and I got them to play Cuphead as well. It's fun to have 2 peripherals, I guess. I also formatted my SSD to remove the encryption on it as I thought it was slowing down my games.

			One thing I am happy today was that I got Wangan Midnight to run on Linux! **Finally** I have 1 less reason to use Windows. I think I have all of my favorite games running on Linux now and I'm proud to see how viable it is for gaming. It worked well and I was able to have fun on it and finished some parts of the story mode.

			I'm trying to learn how to use manual transmission in games. Shifting is very hard for me, I have to time it right and know when to shift up or down. I really hope I can buy that racing controller with a gear shift. All in all, today was pretty fun. I was able to have an enjoyable Saturday nonetheless.
		`,
		spotify: {
			song: "With You",
			artist: "Oliver Tree",
			link: "https://open.spotify.com/track/44KmuZ16Pj6t9vCenzwxxa?si=40615be7a91e4fbf",
			album: "Alone In A Crowd"
		}
	},
];

export default septemberMap;
